import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      notifications: 'core/notifications',
    }),
  },
  methods: {
    ...mapActions({
      addNotification: 'core/addNotification',
      toggleNotification: 'core/toggleNotification',
      hideNotification: 'core/hideNotification',
    }),
  },
};
